import {
    AfterViewInit, ElementRef, EventEmitter, Input,
    Output, Component, ViewChild, forwardRef, OnInit, OnChanges, SimpleChanges, OnDestroy, AfterViewChecked
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'vf-bootstrap-select-picker',
    template: `
        <!-- <select #selectPicker name="selectPicker" [attr.data-max-options]="singleSelect ? 1 : null"
            [attr.data-live-search]="noDataLiveSearch ? null: true" [attr.data-dropup-auto]="noDropUp ? false: null"
            multiple [ngClass]="cssClasses" [attr.data-live-search-placeholder]="placeholder" [title] ="title" [disabled]="isDisabled">
            <option *ngFor= "let option of selectedOptions" [value]="option.id">{{option.name}}</option>
        </select> -->
        <select #selectPicker name="selectPicker" [attr.data-live-search]="noDataLiveSearch ? null: true"
            [attr.data-dropup-auto]="noDropUp ? false: null"
            [ngClass]="cssClasses" [disabled]="isDisabled">
                <option *ngFor= "let option of selectedOptions" [value]="option.id">{{option.name}}</option>
        </select>
    `,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => BootstrapSelectPickerComponent),
        }
    ]
})
export class BootstrapSelectPickerComponent implements AfterViewChecked, ControlValueAccessor, OnInit, OnChanges, OnDestroy {

    @ViewChild('selectPicker') selectPicker: ElementRef;

    @Input() value = '';
    @Input() singleSelect: boolean;
    @Input() bootstrapSelectOptions: any = undefined;
    @Input() noDataLiveSearch: boolean;
    @Input() noDropUp: boolean;
    @Input() selectOptions: any;
    @Input() valueColumnName: any;
    @Input() idColumnName: any;
    @Input() isDisabled: boolean;
    @Input() cssClasses: string;
    @Input() placeholder: string;
    @Input() disabled: boolean;

    @Output() selectChange = new EventEmitter();

    selectedOptions: any;
    private onTouched = () => { };
    private onChange: (value: any) => void = () => { };

    constructor() { }

    private mapOptions(items): any {
        const result = items.map((item) => {
            return {
                id: item[this.idColumnName],
                name: item[this.valueColumnName]
            };
        });
        return result;
    }

    ngOnInit(): void {
        if (typeof this.selectOptions !== 'undefined') {
            this.selectedOptions = this.mapOptions(this.selectOptions);
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.selectOptions && changes.selectOptions.currentValue) {
            this.selectedOptions = this.mapOptions(changes.selectOptions.currentValue);

            setTimeout(() => {
                const $element = $(this.selectPicker.nativeElement);
                $($element).selectpicker('destroy');
                $element.off();
                this.initializeBsPicker($element);
            }, 100);
        }
        $('.bootstrap-select .btn').each(() => {
            $(this).data('title', $(this).attr('title')).removeAttr('title');
        });
    }


    ngAfterViewChecked(): void {
        const $element = $(this.selectPicker.nativeElement);
        // this.initializeBsPicker($element);
        if ($element.hasClass('time-zone-picker')) {
            $element.next().addClass('btn dropdown-toggle btn-light bg-light border-0 text-museo-sans font-weight-500 f-size-14');
        }
    }

    ngOnDestroy(): void {
        const $element = $(this.selectPicker.nativeElement);
        $element.off();
        $($element).selectpicker('destroy');
    }

    writeValue(value: any): void {
        setTimeout(() => {
            this.value = value;
            $(this.selectPicker.nativeElement).selectpicker('val', value);
            $('.bootstrap-select .btn').each(() => {
                $(this).data('title', $(this).attr('title')).removeAttr('title');
            });
        }, 300);
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        const $element = $(this.selectPicker.nativeElement);
        if (isDisabled) {
            $($element).prop('disabled', true);
            $($element).addClass('disabled');
        } else {
            $($element).prop('disabled', false);
            $($element).removeClass('disabled');
        }
        $($element).selectpicker('refresh');
        $('.bootstrap-select .btn').each(() => {
            $(this).data('title', $(this).attr('title')).removeAttr('title');
        });
    }

    private initializeBsPicker($element): void {
        if (!this.bootstrapSelectOptions) {
            this.bootstrapSelectOptions = {
                size: 5,
                noneSelectedText: '--'
            };
        }

        let bsOptions = {
            container: 'body',
            mobile: false
        };

        if (navigator.userAgent.match(/like Mac OS X/i)) {
            bsOptions = {
                container: 'body',
                mobile: true
            };
        }

        //  $element.unbind();
        $element.selectpicker($.extend(true, bsOptions, this.bootstrapSelectOptions));

        $element.on('changed.bs.select', (e) => {
            let value = $element.selectpicker('val');
            value = value === 'undefined' || value === 'null' ? null : value;
            this.value = value;
            this.onChange(this.value);
            this.onTouched();
            this.selectChange.next(this.value);

            $('.bootstrap-select .btn').each(() => {
                $(this).data('title', $(this).attr('title')).removeAttr('title');
            });
        });
        $element.on('show.bs.select', (e) => {
            setTimeout(() => {
                const dropdownMenuItems = $('.bs-container.dropdown').find('[role="listbox"]').attr('tabindex', -1);
                const selectedItem = $('.bs-container.dropdown .dropdown-menu.inner.show li.selected');
                if (selectedItem.length > 0) {
                    dropdownMenuItems.scrollTop(0);
                    const target = Math.abs(selectedItem.position().top);
                    dropdownMenuItems.scrollTop(target);
                }
            }, 50);
        });
    }
}
